import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import { OfferItemDialogComponent } from '../offer-item-dialog/offer-item-dialog.component';

import * as _ from 'lodash';

@Component({
    selector: 'app-modifier-group',
    templateUrl: './modifier-group.component.html',
    styleUrl: './modifier-group.component.scss',
    standalone: false
})
export class ModifierGroupComponent implements OnInit {
	@Input() public viewItem;
	@Input() public currentItem;
	@Input() public group;
	@Input() public workMode;

	@Output() public onMemberSelect: any = new EventEmitter();

	$storage;
	catalog;
	showItemDescription: boolean = false;
	constructor(
		public appService: AppService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public dialog: MatDialog
	) {
		this.$storage = this.orderService.$storage;
		this.catalog = this.$storage.catalog;
	}

	ngOnInit(): void {
		this.showItemDescription = this.group.showItemDescription;
	}

	collapseGroup(group) {
		group.collapsed = !group.collapsed;
	}

	// ----------------------------------------------------------------------------->
	// single selection
	// ----------------------------------------------------------------------------->

	addMGroupSingle(group, member, e) {
		delete group._isopen;
		if (member._selected) {
			//delete item._selected;
		} else {
			var selected = _.find(group.modifiers, { '_selected': true });
			if (selected) delete selected._selected;
			member._selected = true;
			delete group._requiered;
		}
		//$scope.ES.prepareItemSummary($scope.currentItem); //new summary
	}

	// ----------------------------------------------------------------------------->
	// multy selection
	// ----------------------------------------------------------------------------->

	toggleMGroupMulti(group, member, placement) {
		if (member.formationUnit) this.addMGroupMulti(group, member);
		else {
			if (!placement) {
				alert("Missing item formations");
				return;
			};
			this.addMGroupMulti(group, member, placement);
		}
	}

	addRemoveMGroupMultiStart(group, member, placement, doAdd, ev) {
		ev.stopPropagation();
		const h = ev.currentTarget as HTMLElement;
		if (h.classList.contains('popactive')) {
			h.classList.remove('popactive')
			return;
		}
		document.querySelectorAll('.popactive').forEach(el => el.classList.remove('popactive'));
		h.classList.add('popactive');
		if (!member.formationUnit) this.addRemoveMGroupMulti(group, member, placement, doAdd, ev);
	}

	addRemoveMGroupMulti(group, member, placement, doAdd, ev) {
		if (ev) ev.stopPropagation();
		if (!doAdd) this.addMGroupMulti(group, member);
		else {
			if (!placement) {
				alert("Missing item formations");
				return;
			}
			this.addMGroupMulti(group, member, placement);
		}
	}

	addMGroupMulti(group, member, placement?, silent?) {
		const price = member.price;
		if (!placement) {
			if (price > 0) {
				if (this.workMode == 'offer') this.viewItem.total -= price;
				else this.currentItem.total -= price;
			}
			--member.count;
			if (!member.count) delete member.formationUnit;
			if (silent) return;
		} else {
			if (member.item && this.workMode == 'offer' && !member._itemPrepared) {
				member._itemPrepared = true;
				let refItem: any = _.find(this.catalog.items, { "_id": member.item });
				if (refItem) {
					member._item = _.cloneDeep(refItem);
					this.orderUtils.prepareItem(this.catalog, member._item, {});
					member._enableEdit = member._item._enableEdit;
				}
			}
			if (group.max) {
				var count = 0;
				var elms = _.filter(group.modifiers, function (elem) {
					if (elem.formationUnit != null) {
						count += elem.count;
						return true;
					}
				});

				if (count >= group.max) {
					if (count == 1) {
						this.addMGroupMulti(group, elms[0], null, true);
					} else {
						var maxOP = group.compulsaryOP || 0;
						this.appService.alert({ content: this.appService.translate("GROUP_VALIDATION.MOD_CANT_SELECT_MORE_THEN", { name: group.name, max: count - maxOP }) });
						return;
					}
				}
			}
			if (!member.formationUnit && member._item?._hasRequiered) {
				return	this.editItemGroupItem(group, member, null);
			}
			this.onMgroupMemberAdd(group, member, placement);
		}
		this.orderUtils.checkModGroupSelection(group);
	}

	onMgroupMemberAdd(group, member, placement) {
		let price = member.price;
		if (price > 0) {
			if (this.workMode == 'offer') this.viewItem.total += price;
			else this.currentItem.total += price;
		}
		member.formationUnit = placement;
		if (!member.count) member.count = 1;
		else ++member.count;
	}

	editItemGroupItem(group, member, e?) {
		if (e) e.stopPropagation();
		return this.showSelectionGroupItemModal({
			viewItem: this.viewItem,
			groupItem: member,
			group: group,
			currentItem: member._item,
			currentItemPrice: member.price,
			isEditSGItem: true
		})
	}

	clearSelectionGroupItem(group, member, e?) {
		if (e) e.stopPropagation();
		let _item = member._item;
		if (_item) {
			delete _item.oldTotal;
			_item.total = _item._total;

			delete member._item.oldTotal;
			member._item.total = member._item._total;
			delete member._item.summary;


			const price = member.price;
			for (let i = 0; i < member.count; i++) {
				if (price > 0) {
					if (this.workMode == 'offer') this.viewItem.total -= price;
					else this.currentItem.total -= price;
				}
				--member.count;
			}
			delete member.formationUnit;

			_.each(member._item.modifierGroups, group => {
				if (group.singleSelection) {
					_.each(group.modifiers, modifier => {
						if (modifier._isDefault) {
							modifier._selected = true;
						} else {
							delete modifier._selected;
						}
					})
				} else {
					_.each(group.modifiers, modifier => {
						if (!modifier.compulsory) {
							if (modifier.$isDefault) {
								modifier.formationUnit = modifier.defaultFormationUnit;
								modifier.count = 1;
							} else {
								delete modifier.formationUnit;
								modifier.count = 0;
							}
						}
					})
				}
			})
			this.orderUtils.checkModGroupSelection(group);
		}
	}

	showSelectionGroupItemModal(args) {
		let dialogRef = this.dialog.open(OfferItemDialogComponent, {
			panelClass: ['to-offer-dialog', 'animated', 'slideInLeft'],
			data: args,
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				if (result.isClear) {
					this.clearSelectionGroupItem(args.group, args.groupItem);
				} else {
					if (!args.groupItem.formationUnit) {
						this.onMgroupMemberAdd(args.group, args.groupItem, this.currentItem.formation[0]);
					}

					this.orderUtils.prepareItemSummary(result.groupItem._item, true);
					args.groupItem.$wasEdit = true;
					this.orderUtils.checkModGroupSelection(args.group);
				}
			}
		});
	}
}
